enum GlowColourEnum {
  None = 'none',
  Yellow = 'yellow',
  Red = 'red',
  YellowFaint = 'yellow-faint',
}

export default GlowColourEnum;
